var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyInvoices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 442.511,
    height: 270.432,
    viewBox: "0 0 442.511 270.432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5062",
    "data-name": "Group 5062",
    transform: "translate(-1214 -491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5012",
    "data-name": "Group 5012",
    transform: "translate(1229.698 526.996)",
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4996",
    "data-name": "Group 4996",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3350",
    "data-name": "Rectangle 3350",
    width: 99.302,
    height: 146.218,
    transform: "matrix(0.831, -0.556, 0.556, 0.831, 0, 55.208)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4999",
    "data-name": "Group 4999",
    transform: "translate(79.222 95.094)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4997",
    "data-name": "Group 4997",
    transform: "translate(0 14.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6110",
    "data-name": "Path 6110",
    d: "M257.336,277.535l-.937,5.8-41.032-5.911.937-5.8Z",
    transform: "translate(-215.368 -271.624)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4998",
    "data-name": "Group 4998",
    transform: "translate(14.776)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6111",
    "data-name": "Path 6111",
    d: "M241.983,251.546l5.888.848-6.528,40.4-5.888-.848Z",
    transform: "translate(-235.454 -251.546)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5001",
    "data-name": "Group 5001",
    transform: "translate(88.857 46.138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5000",
    "data-name": "Group 5000"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6112",
    "data-name": "Path 6112",
    d: "M228.466,184.995",
    transform: "translate(-228.466 -184.995)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5003",
    "data-name": "Group 5003",
    transform: "translate(25.571 43.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5002",
    "data-name": "Group 5002"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6113",
    "data-name": "Path 6113",
    d: "M179.6,181.745c.059.088-8.213,5.724-18.473,12.586s-18.629,12.357-18.688,12.269,8.211-5.722,18.474-12.587S179.538,181.657,179.6,181.745Z",
    transform: "translate(-142.436 -181.744)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5005",
    "data-name": "Group 5005",
    transform: "translate(31.432 36.127)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5004",
    "data-name": "Group 5004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6114",
    "data-name": "Path 6114",
    d: "M212.058,171.387c.059.088-13.7,9.392-30.72,20.777s-30.876,20.549-30.935,20.461,13.694-9.389,30.722-20.779S212,171.3,212.058,171.387Z",
    transform: "translate(-150.403 -171.386)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5007",
    "data-name": "Group 5007",
    transform: "translate(37.517 45.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5006",
    "data-name": "Group 5006"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6115",
    "data-name": "Path 6115",
    d: "M220.329,183.753c.059.088-13.7,9.392-30.719,20.778s-30.876,20.548-30.935,20.461,13.694-9.389,30.722-20.779S220.27,183.665,220.329,183.753Z",
    transform: "translate(-158.675 -183.752)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5009",
    "data-name": "Group 5009",
    transform: "translate(43.601 54.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5008",
    "data-name": "Group 5008"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6116",
    "data-name": "Path 6116",
    d: "M228.6,196.12c.059.088-13.7,9.391-30.719,20.777S167,237.445,166.946,237.357s13.694-9.389,30.722-20.779S228.541,196.031,228.6,196.12Z",
    transform: "translate(-166.946 -196.119)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5011",
    "data-name": "Group 5011",
    transform: "translate(49.686 63.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5010",
    "data-name": "Group 5010"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6117",
    "data-name": "Path 6117",
    d: "M236.871,208.486c.059.088-13.7,9.392-30.72,20.777s-30.876,20.549-30.935,20.461,13.694-9.389,30.722-20.778S236.813,208.4,236.871,208.486Z",
    transform: "translate(-175.217 -208.485)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5029",
    "data-name": "Group 5029",
    transform: "translate(1518.92 608.45)",
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5013",
    "data-name": "Group 5013",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3351",
    "data-name": "Rectangle 3351",
    width: 83.397,
    height: 122.798,
    transform: "translate(0 46.365) rotate(-33.777)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5016",
    "data-name": "Group 5016",
    transform: "translate(66.533 79.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5014",
    "data-name": "Group 5014",
    transform: "translate(0 12.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6118",
    "data-name": "Path 6118",
    d: "M626.532,363.4l-.787,4.869-34.46-4.964.787-4.869Z",
    transform: "translate(-591.285 -358.431)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5015",
    "data-name": "Group 5015",
    transform: "translate(12.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6119",
    "data-name": "Path 6119",
    d: "M613.637,341.569l4.945.712L613.1,376.21l-4.945-.712Z",
    transform: "translate(-608.155 -341.569)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5018",
    "data-name": "Group 5018",
    transform: "translate(74.624 38.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5017",
    "data-name": "Group 5017"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6120",
    "data-name": "Path 6120",
    d: "M602.285,285.678",
    transform: "translate(-602.285 -285.678)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5020",
    "data-name": "Group 5020",
    transform: "translate(21.475 36.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5019",
    "data-name": "Group 5019"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6121",
    "data-name": "Path 6121",
    d: "M561.244,282.948c.059.088-6.88,4.832-15.5,10.6s-15.653,10.366-15.711,10.278,6.879-4.831,15.5-10.6S561.185,282.86,561.244,282.948Z",
    transform: "translate(-530.034 -282.946)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5022",
    "data-name": "Group 5022",
    transform: "translate(26.397 30.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5021",
    "data-name": "Group 5021"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6122",
    "data-name": "Path 6122",
    d: "M588.5,274.249c.059.088-11.485,7.913-25.781,17.475s-25.939,17.246-26,17.158,11.483-7.911,25.784-17.477S588.446,274.161,588.5,274.249Z",
    transform: "translate(-536.726 -274.248)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5024",
    "data-name": "Group 5024",
    transform: "translate(31.508 37.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5023",
    "data-name": "Group 5023"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6123",
    "data-name": "Path 6123",
    d: "M595.452,284.635c.059.088-11.486,7.912-25.782,17.475s-25.938,17.246-26,17.158,11.483-7.911,25.784-17.476S595.393,284.546,595.452,284.635Z",
    transform: "translate(-543.673 -284.634)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5026",
    "data-name": "Group 5026",
    transform: "translate(36.617 45.619)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5025",
    "data-name": "Group 5025"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6124",
    "data-name": "Path 6124",
    d: "M602.4,295.02c.059.088-11.485,7.913-25.781,17.475s-25.939,17.246-26,17.158,11.483-7.911,25.784-17.476S602.339,294.932,602.4,295.02Z",
    transform: "translate(-550.619 -295.019)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5028",
    "data-name": "Group 5028",
    transform: "translate(41.728 53.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5027",
    "data-name": "Group 5027"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6125",
    "data-name": "Path 6125",
    d: "M609.345,305.406c.059.088-11.486,7.912-25.782,17.475s-25.938,17.246-26,17.158,11.483-7.911,25.784-17.476S609.286,305.318,609.345,305.406Z",
    transform: "translate(-557.566 -305.405)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5046",
    "data-name": "Group 5046",
    transform: "translate(1343.374 491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5030",
    "data-name": "Group 5030",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3352",
    "data-name": "Rectangle 3352",
    width: 85.773,
    height: 126.298,
    transform: "matrix(0.882, 0.472, -0.472, 0.882, 59.563, 0)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5033",
    "data-name": "Group 5033",
    transform: "translate(36.604 83.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5031",
    "data-name": "Group 5031",
    transform: "translate(9.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6126",
    "data-name": "Path 6126",
    d: "M341.32,220.266l-4.8,1.643-12.18-33.672,4.8-1.643Z",
    transform: "translate(-324.341 -186.594)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5032",
    "data-name": "Group 5032",
    transform: "translate(0 9.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6127",
    "data-name": "Path 6127",
    d: "M345.405,199.529l1.748,4.832-33.441,11.453-1.748-4.832Z",
    transform: "translate(-311.964 -199.529)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5035",
    "data-name": "Group 5035",
    transform: "translate(102.607 64.026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5034",
    "data-name": "Group 5034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6128",
    "data-name": "Path 6128",
    d: "M401.689,160.379",
    transform: "translate(-401.689 -160.379)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5037",
    "data-name": "Group 5037",
    transform: "translate(59.753 24.931)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5036",
    "data-name": "Group 5036"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6129",
    "data-name": "Path 6129",
    d: "M377.486,125.447c-.059.111-7.731-3.876-17.132-8.9s-16.979-9.2-16.92-9.306,7.729,3.876,17.134,8.905S377.545,125.337,377.486,125.447Z",
    transform: "translate(-343.434 -107.234)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5039",
    "data-name": "Group 5039",
    transform: "translate(55.46 32.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5038",
    "data-name": "Group 5038"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6130",
    "data-name": "Path 6130",
    d: "M394.093,148.367c-.059.11-12.755-6.564-28.354-14.907s-28.2-15.2-28.142-15.308,12.752,6.562,28.356,14.907S394.152,148.256,394.093,148.367Z",
    transform: "translate(-337.597 -118.151)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5041",
    "data-name": "Group 5041",
    transform: "translate(51.001 41.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5040",
    "data-name": "Group 5040"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6131",
    "data-name": "Path 6131",
    d: "M388.032,159.7c-.06.11-12.756-6.564-28.354-14.907s-28.2-15.2-28.142-15.309,12.753,6.562,28.357,14.908S388.091,159.588,388.032,159.7Z",
    transform: "translate(-331.536 -129.482)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5043",
    "data-name": "Group 5043",
    transform: "translate(46.543 49.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5042",
    "data-name": "Group 5042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6132",
    "data-name": "Path 6132",
    d: "M381.972,171.03c-.059.111-12.755-6.564-28.354-14.906s-28.2-15.2-28.142-15.309,12.752,6.562,28.357,14.908S382.031,170.92,381.972,171.03Z",
    transform: "translate(-325.476 -140.814)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5045",
    "data-name": "Group 5045",
    transform: "translate(42.085 57.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5044",
    "data-name": "Group 5044"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6133",
    "data-name": "Path 6133",
    d: "M375.911,182.362c-.06.111-12.756-6.564-28.354-14.906s-28.2-15.2-28.143-15.309,12.753,6.562,28.357,14.908S375.97,182.252,375.911,182.362Z",
    transform: "translate(-319.415 -152.146)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(1214 760.403)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5048",
    "data-name": "Group 5048",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5047",
    "data-name": "Group 5047"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6134",
    "data-name": "Path 6134",
    d: "M511.031,439.759c0,.106-95.079.192-212.338.192-117.3,0-212.359-.086-212.359-.192s95.059-.191,212.359-.191C415.952,439.568,511.031,439.654,511.031,439.759Z",
    transform: "translate(-86.334 -439.568)",
    fill: "#758ca1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "translate(1229.698 714.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5058",
    "data-name": "Group 5058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5049",
    "data-name": "Group 5049",
    transform: "translate(5.087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6135",
    "data-name": "Path 6135",
    d: "M117.309,377.2a9.273,9.273,0,0,1,6.462,3.31,16.371,16.371,0,0,1,3.29,6.629c1.245,4.652.48,10.141-.847,14.771-5.035-1.8-8.141-7.171-9.545-9.994-2.219-4.462-3.521-13.875.641-14.715",
    transform: "translate(-114.589 -377.201)",
    fill: "#24dcae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5050",
    "data-name": "Group 5050",
    transform: "translate(22.7 17.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6136",
    "data-name": "Path 6136",
    d: "M139.79,413.66a7.911,7.911,0,0,1-.371-7.934,10.509,10.509,0,0,1,6.327-5.085,4.426,4.426,0,0,1,3.724.178,3.385,3.385,0,0,1,1.3,3.172,6.855,6.855,0,0,1-1.448,3.255c-2.448,3.315-5.427,6.074-9.534,6.415",
    transform: "translate(-138.532 -400.32)",
    fill: "#24dcae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5052",
    "data-name": "Group 5052",
    transform: "translate(23.046 22.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5051",
    "data-name": "Group 5051"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6137",
    "data-name": "Path 6137",
    d: "M140.468,431.224a5.558,5.558,0,0,1-.225-.966l-.518-2.651a27.763,27.763,0,0,1-.551-8.9,17,17,0,0,1,3.3-8.252,11.577,11.577,0,0,1,1.91-1.931,7.1,7.1,0,0,1,.6-.43c.141-.093.218-.136.224-.127a18.145,18.145,0,0,0-2.539,2.638,17.549,17.549,0,0,0-3.153,8.149,29.9,29.9,0,0,0,.448,8.814c.18,1.125.326,2.038.409,2.671A5.239,5.239,0,0,1,140.468,431.224Z",
    transform: "translate(-139.003 -407.961)",
    fill: "#758ca1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5054",
    "data-name": "Group 5054",
    transform: "translate(9.429 7.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5053",
    "data-name": "Group 5053"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6138",
    "data-name": "Path 6138",
    d: "M120.493,386.826a2.029,2.029,0,0,1,.2.382l.519,1.121c.445.976,1.07,2.4,1.829,4.158,1.517,3.523,3.545,8.419,5.662,13.876s3.92,10.444,5.175,14.069c.627,1.812,1.123,3.282,1.453,4.3.152.483.276.874.372,1.178a1.958,1.958,0,0,1,.107.419,2.061,2.061,0,0,1-.174-.4l-.435-1.156-1.557-4.266c-1.314-3.6-3.153-8.569-5.268-14.025s-4.106-10.361-5.564-13.907l-1.727-4.2c-.188-.471-.34-.851-.458-1.147A2,2,0,0,1,120.493,386.826Z",
    transform: "translate(-120.492 -386.826)",
    fill: "#758ca1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5055",
    "data-name": "Group 5055",
    transform: "translate(0 26.661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6139",
    "data-name": "Path 6139",
    d: "M126.208,422.389a18.5,18.5,0,0,0-14.361-8.922c-1.488-.108-3.279.142-3.943,1.479s.224,2.924,1.238,4.023a15.811,15.811,0,0,0,17.121,3.822",
    transform: "translate(-107.674 -413.445)",
    fill: "#24dcae"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5057",
    "data-name": "Group 5057",
    transform: "translate(6.44 30.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5056",
    "data-name": "Group 5056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6140",
    "data-name": "Path 6140",
    d: "M116.429,418.888a4.825,4.825,0,0,1,.932.035,9.029,9.029,0,0,1,1.087.126c.419.079.908.124,1.427.268a16.382,16.382,0,0,1,1.7.472,18.4,18.4,0,0,1,1.892.719,20.608,20.608,0,0,1,3.985,2.363,20.169,20.169,0,0,1,3.294,3.26,17.6,17.6,0,0,1,1.16,1.659,14.8,14.8,0,0,1,.863,1.536,13.692,13.692,0,0,1,.593,1.326,8.344,8.344,0,0,1,.37,1.031,4.836,4.836,0,0,1,.243.9c-.074.026-.433-1.26-1.424-3.143a16.157,16.157,0,0,0-.888-1.493,18.633,18.633,0,0,0-1.167-1.614,20.923,20.923,0,0,0-3.257-3.184,21.386,21.386,0,0,0-3.9-2.346,19.2,19.2,0,0,0-1.852-.738,17.327,17.327,0,0,0-1.663-.506C117.752,419.035,116.421,418.964,116.429,418.888Z",
    transform: "translate(-116.429 -418.876)",
    fill: "#758ca1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5059",
    "data-name": "Group 5059",
    transform: "translate(1340.993 600.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6141",
    "data-name": "Path 6141",
    d: "M288.385,231.3,262.373,365.034l-3.405,17.507,173.653-.856c7.793-.038,14.7-6.958,17.208-17.239l30.792-126.26c1.9-7.8-2.273-15.922-8.189-15.916l-175.757.185C292.794,222.459,289.4,226.08,288.385,231.3Z",
    transform: "translate(-258.968 -222.27)",
    fill: "#e8505b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5060",
    "data-name": "Group 5060",
    transform: "translate(1340.993 600.554)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6142",
    "data-name": "Path 6142",
    d: "M288.385,231.3,262.373,365.034l-3.405,17.507,173.653-.856c7.793-.038,14.7-6.958,17.208-17.239l30.792-126.26c1.9-7.8-2.273-15.922-8.189-15.916l-175.757.185C292.794,222.459,289.4,226.08,288.385,231.3Z",
    transform: "translate(-258.968 -222.27)",
    fill: "#f2a35b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5061",
    "data-name": "Group 5061",
    transform: "translate(1277.441 575.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6143",
    "data-name": "Path 6143",
    d: "M393.123,346.975l-18.386-148.16c-.753-6.07-5.589-10.6-11.3-10.58l-40.317.132a10.987,10.987,0,0,0-7.964,3.532l-19.145,20.35-112.128.586c-6.852.035-12.116,6.519-11.208,13.8l17.07,136.938c.756,6.062,5.583,10.584,11.284,10.573l195.415-.386c21.765.451,23.842-5.977,23.842-5.977C395.347,373.314,393.125,346.992,393.123,346.975Z",
    transform: "translate(-172.575 -188.235)",
    fill: "#fcb151"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5141",
    "data-name": "Path 5141",
    d: "M93.422,83.591a21.411,21.411,0,1,0-11.781,19.05l12.693,12.7a7.147,7.147,0,1,0,10.1-10.109l-12.9-12.905A21.2,21.2,0,0,0,93.422,83.591Zm-21.337,17.5a17.5,17.5,0,1,1,17.494-17.5A17.516,17.516,0,0,1,72.085,101.086Zm29.64,6.86a3.312,3.312,0,0,1,0,4.671,3.388,3.388,0,0,1-4.676,0l-12.065-12.07a21.454,21.454,0,0,0,4.581-4.76Z",
    transform: "translate(1311.082 597.098)",
    fill: "#ed795b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyInvoices);
export default __webpack_public_path__ + "static/media/empty-invoices.de146787.svg";
export { ForwardRef as ReactComponent };